import {
  appLogout,
  createAsyncThunk,
  createSlice,
  injectSlice,
  persistReducer,
} from '@betty/toolkit/state';
import { DepositCountState } from './depositCount.types';
import WalletService from '../../services/WalletService/WalletService';
import { AsyncStorage } from '@betty/toolkit/storage';

export const getDepositCount = createAsyncThunk(
  'depositCount/get',
  async () => await WalletService.getDepositCount(),
);

const initialState: DepositCountState = {
  data: undefined,
  dataState: 'idle',
};

const depositCount = createSlice({
  name: 'depositCount',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getDepositCount.pending, (state) => {
      state.dataState = 'pending';
    });

    builder.addCase(getDepositCount.fulfilled, (state, { payload }) => {
      const { successfulDepositCount } = payload;

      state.dataState = 'fulfilled';
      state.data = successfulDepositCount;
    });

    builder.addCase(getDepositCount.rejected, (state) => {
      state.dataState = 'rejected';
    });

    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

const persistConfig = {
  key: 'depositCount',
  storage: AsyncStorage,
  whitelist: ['data'],
};

const persistedReducer = persistReducer(persistConfig, depositCount.reducer);

const withDepositCount = injectSlice({
  reducerPath: 'depositCount',
  reducer: persistedReducer,
});

export const selectDepositCount = withDepositCount.selector(
  (state) => state.depositCount.data,
);

export const selectDepositCountState = withDepositCount.selector(
  (state) => state.depositCount.dataState,
);

export const selectHasUserDeposited = withDepositCount.selector((state) =>
  Boolean(state.depositCount.data),
);

declare global {
  interface LazyLoadedSlices {
    depositCount: ReturnType<typeof persistedReducer>;
  }
}
